import { ENTRY_ROUTE_MARKS, type RouteMark } from '@daghfal/core';

/**
 * Every route `App.tsx` declares, marked where its screen shows a child's data, which the shell then draws
 * under the viewer watermark (Q40, Q49). A route added to `App.tsx` and not here fails
 * `routeMarks.test.ts`, so a new screen cannot ship unmarked by accident.
 */
export const GUARDIAN_ROUTES: readonly RouteMark[] = [
  ...ENTRY_ROUTE_MARKS,
  // The chooser lists the family's children, with their photos.
  { route: 'index', path: '/', childData: true },
  { route: 'child/:childId/*', path: '/child/:childId/*', childData: false },
  // A notification's link with no child in it: each only finds the child and moves on.
  { route: 'messages/:conversationId', path: '/messages/:conversationId', childData: false },
  { route: 'complaints/:complaintId', path: '/complaints/:complaintId', childData: false },
  { route: 'announcements/*', path: '/announcements/*', childData: false },
  { route: 'account', path: '/account', childData: false },
  { route: '*', path: '*', childData: false },
  // Everything below one child.
  { route: 'index', path: '/child/:childId', childData: true },
  { route: 'day', path: '/child/:childId/day', childData: true },
  { route: 'photos', path: '/child/:childId/photos', childData: true },
  { route: 'messages', path: '/child/:childId/messages', childData: true },
  { route: 'payments', path: '/child/:childId/payments', childData: true },
  { route: 'attendance', path: '/child/:childId/attendance', childData: true },
  // A complaint names the child it concerns.
  { route: 'complaints', path: '/child/:childId/complaints', childData: true },
  { route: 'complaints/:complaintId', path: '/child/:childId/complaints/:complaintId', childData: true },
  { route: 'notifications', path: '/child/:childId/notifications', childData: false },
  // The child's incidents, and one in full: what happened to them, where, and what was done.
  { route: 'incidents', path: '/child/:childId/incidents', childData: true },
  { route: 'incidents/:incidentId', path: '/child/:childId/incidents/:incidentId', childData: true },
  // A medication record's link, on to the notification centre.
  { route: 'health', path: '/child/:childId/health', childData: false },
  { route: 'info', path: '/child/:childId/info', childData: true },
  // The nursery's closures, holidays and trips: no child is named.
  { route: 'calendar', path: '/child/:childId/calendar', childData: false },
  { route: '*', path: '/child/:childId/*', childData: false },
];
